import React from 'react';

export const deParaAnexos = {
  Emprestimo: 'Empréstimos',
  Emprestimo2: 'Empréstimos',
  Emprestimo3: 'Empréstimos',

  CertidaoDeObito: 'Certidão de óbito*',
  RG: 'RG*',
  CPF: 'CPF*',
  Outros: 'Outros',
  Termos: 'Termo de Opcao Percentual de Pagamento RCM em Valor Variável',
  LaudoSUS:
    'Cópia autenticada do laudo emitido por órgão oficial (SUS/INSS) em papel timbrado* OU Formulário de Informações Complementares*',
  CertidaoCasamentoOuNascimento:
    'Certidão Civil do Participante (Certidão de casamento/nascimento do participante falecido)*',
  CertidaoCasamentoOuNascimentoParticipante:
    'Certidão de casamento/nascimento do Participante',
  CartaConcessaoINSS:
    'Carta de concessão do INSS (se titular faleceu em atividade)',
  CertidaoCasamento: 'Certidão de casamento*',
  CertidaoNascimento: 'Certidão de nascimento*',
  LaudoINSS:
    'Laudo emitido pelo INSS OU Formulário de Informações Médicas Complementares',
  LaudoMedicoIsencao: 'Laudo médico',
  LaudoMedico: 'Laudo médico que comprove a invalidez (perícia)*',
  CertidaoCasamentoGenitor:
    'Certidão de casamento entre o participante e genitor do enteado*',
  DeclaracaoNaoEmancipacao: 'Declaração de não emancipação*',
  DependeciaEconomica: 'Comprovação de dependência econômica do enteado*',
  IRSegurado:
    'Declaração do imposto de renda do segurado, em que conste o interessado como seu dependente*',
  Testamentarias: 'Disposições testamentárias',
  ProvaVidaCivil:
    'Prova de encargos domésticos evidentes e existência de sociedade ou comunhão nos atos da vida civil*',
  Procuracao: 'Procuração ou fiança reciprocamente outorgada;',
  AnotacaoFicha:
    'Anotação constante de ficha ou Livro de Registro de empregados*',
  FichaTratamentoMedico:
    'Ficha de tratamento em instituição de assistência médica da qual conste o segurado como responsável;',
  EscrituraImovel:
    'Escritura de compra e venda de imóvel pelo segurado em nome do dependente*',
  QuaisquerOutros:
    'Quaisquer outros documentos que possam levar à convicção do fato a comprovar*',
  ProvaDomicilio: 'Prova de mesmo domicílio*',
  SB40: 'SB40*',
  DIRBEN: 'DIRBEN*',
  PPP: 'PPP*',
  CienciaConcessao:
    'Termo de ciência e compromisso para concessão de benefício*',
  Decisao: 'Comunicação de Decisão',
  CTPS: 'CTPS (página identificação e contratos)* OU CNIS*',
  CertReservista: 'Certificado de reservista OU Carnê de contribuição autônoma',
  Carta: 'Carta de concessão e memória de cálculo*',
  CartaRevisada: 'Carta de concessão e memória de cálculo revisada*',
  CartaInicial: 'Carta de concessão e memória de cálculo inicial*',
  Herdeiro:
    'Escritura Pública de Inventário e Partilha firmada em cartório *' +
    'OU Inventário judicial*',
  DeclaracaoHerdeiros: 'Declaração de Únicos Herdeiros*',
  SentecaJudicial: 'Sentença judicial*',
  MovimentacaoProcessualAtualizada: 'Movimentação Processual Atualizada*',
  TermoMAI: 'Termo de Opcao Forma de Pagamento MAI',
  Convivente: (
    <ul>
      <p>
        Insira um ou mais arquivos das seguintes opções (caso seja inserida
        declaração escrita de união estável, pelo menos um tipo de documento
        relacionado no bloco de anexos subsequente é obrigatório)
      </p>
      <li>Declaração de Imposto de Renda do participante*</li>
      <li>Certidão de nascimento de filho havido em comum*</li>
      <li>Escritura pública atestando a união estável *</li>
      <li>Declaração escrita de união estável*</li>
    </ul>
  ),
  CasoUniaoEstavel: (
    <ul>
      <li>
        Anotação constante na Carteira Profissional e/ou na Carteira de Trabalho
        e Previdência Social - CTPS feita pelo Ministério do Trabalho, através
        da Delegacia Regional do Trabalho*
      </li>
      <li>
        Declaração especial feita perante tabelião (escritura pública
        declaratória de dependência econômica) *
      </li>
      <li>Contrato de união estável registrado em cartório*</li>
      <li>Certidão de casamento religioso*</li>
      <li>Prova de mesmo domicílio*</li>
      <li>
        Prova de encargos domésticos evidentes e existência de sociedade ou
        comunhão nos atos da vida civil, com convivência no mesmo domicílio*
      </li>
      <li>
        Registro em associação de qualquer natureza onde conste o companheiro(a)
        como dependente do Participante*
      </li>
      <li>
        Apólice de seguro da qual conste o Participante como instituidor do
        seguro e o(a) companheiro(a) como seu(sua) beneficiário(a) ou
        vice-versa*
      </li>
      <li>Conta bancária conjunta de pessoa física ativa*</li>
    </ul>
  ),
  SB40Etc: (
    <ul>
      <p>Inserir um ou mais dos itens abaixo</p>
      <li>SB40*</li>
      <li>DIRBEN*</li>
      <li>PPP*</li>
      <li>Resumo de contagem de tempo* (apenas caso não aposentado)</li>
      <li>Processo administrativo*</li>
    </ul>
  ),
};
